import axios from 'axios';
import { ACCESS_TYPE, VENDING_URL } from '../../atoms/const';
import findAllRes from './findAll.json';
import getAllCategoriesRes from './getAllCategories.json';
import getByIdRes from './getById.json';

const deleteByColumn = (columnId: string) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}vm-remove-product`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  const data = {
    columnId,
  };
  return axios.post(url, data, config);
};

const findAll = (query?: string, page?: number, size?: number, isBatch?: boolean) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}product-auto-complete?q=${query ?? ''}&page=${page ?? 0}&size=${size ?? 10}&isBatch=${isBatch ?? false}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof findAllRes>(url, config);
};

const getAllByCategoryId = (categoryId:number, page?: number, size?: number, isBatch?: boolean) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}products-by-category?category=${categoryId}&page=${page ?? 0}&size=${size ?? 10}&isBatch=${isBatch ?? false}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof findAllRes>(url, config);
};

const getAllCategories = () => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-all-categories`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getAllCategoriesRes>(url, config);
};

const getById = (id: number) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}get-product?id=${id}`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.get<typeof getByIdRes>(url, config);
};

interface AddNewProduct {
    'upc':string;
    'name':string;
    'unit':number;
    'isBatch':boolean;
    'description':string;
    'categories':number[];
    'productId'?: number;
    samsClubItemNum?: string,
    vistarItemNum?: string,
}

const add = (data:AddNewProduct) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}add-product`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

interface UpdateProduct {
    'id':number;
    'upc':string;
    'name':string;
    'unit':number;
    'isBatch':boolean;
    'description':string;
    'categories':number[];
    'productId'?: number;
    'samsClubItemNum'?: string,
    'vistarItemNum'?: string,
}

const update = (data:UpdateProduct) => {
  const token = sessionStorage.getItem('token');
  const url = `${VENDING_URL}update-product`;
  const config = {
    headers: { Authorization: `${ACCESS_TYPE} ${token}` },
  };
  return axios.post(url, data, config);
};

const product = {
  deleteByColumn,
  findAll,
  add,
  update,
  getAllCategories,
  getAllByCategoryId,
  getById,
};

export default product;
